<template>
  <div>
    <card card-body-classes="table-full-width" no-footer-line>
      <div
        class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
      >
        <h4 class="card-title text-purple">
          {{ title }}
        </h4>
      </div>
      <div class="row col-12 d-flex">
        <!--div class="col-md-6 col-12 row">
          <label class="col-form-label col-12 ">
            {{ $t('app.modules.orders.add.orderType') }}
          </label>
          <div class="col-12">
            <el-select
              v-model="pedido.tipoPedido"
              filterable
              class="d-block"
              :placeholder="$t('app.modules.orders.add.orderType')"
            >
              <el-option
                v-for="item in tiposPedido"
                :key="item['idClasePedido']"
                :label="item['nomenclaturaClase'] + ' - ' + item['descripcionClase']"
                :value="item['idClasePedido']"
              >
              </el-option>
            </el-select>
          </div>
        </div-->
        <div class="col-md-6 col-12 row">
          <label class="col-form-label col-12">
            {{ $t('app.modules.orders.add.business_name') }}
          </label>
          <div class="col-12">
            <el-select
              v-model="pedido.idCliente"
              filterable
              class="d-block"
              :placeholder="$t('app.modules.orders.add.business_name')"
            >
              <el-option
                v-for="item in clientes"
                :key="item.idCliente"
                :label="item.razonSocial"
                :value="item.idCliente"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="row col-md-6 col-12 d-flex">
          <label class="col-form-label col-12">{{$t("app.modules.orders.form.delivery_address")}}</label>
          <div class="col-12">
            <el-select
              v-model="pedido.direccionEntregaId"
              filterable
              :placeholder="$t('app.modules.orders.form.delivery_address')"
              style="display: block"
              clearable
            >
              <el-option
                v-for="item in direcciones"
                :key="item.idDireccion"
                :label="item.text"
                :value="item.idDireccion"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="row col-md-6 col-12 d-flex">
          <label class="col-form-label col-12">
            {{$t("app.modules.orders.form.contact")}}
          </label>
          <div class="col-12">
            <el-select
              v-model="pedido.contactoCliente"
              filterable
              :placeholder="$t('app.modules.orders.form.contact')"
              style="display: block"
              clearable
            >
              <el-option
                v-for="item in contactos"
                :key="item['idContacto']"
                :label="item['nombre']"
                :value="item['idContacto']"
              >
              </el-option>
            </el-select>
          </div>
        </div>
      </div>

      <div class="row col-12 d-flex">
        <el-table stripe style="width: 100%;" :data="productos">
          <el-table-column
            :label="$t('app.modules.orders.headers.code')"
          >
            <template slot-scope="scope">
              {{ scope | product('material') }}
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('app.modules.orders.headers.product_name')"
          >
            <template slot-scope="scope">
              {{ scope | product('denominacion') }}
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('app.modules.orders.headers.price')"
          >
            <template slot-scope="scope">
              {{ scope|product('importe')|currenciFormat() }}
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('app.modules.orders.headers.unit')"
          >
            <template slot-scope="scope">
              {{scope|product('unidadMedida')}}
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('app.modules.orders.headers.money')"
          >
            <template slot-scope="scope">
              {{scope|product('moneda')}}
            </template>
          </el-table-column>
          <!--<el-table-column
            :label="$t('app.modules.orders.headers.delivery_address')"
          >
            <template slot-scope="scope"></template>
          </el-table-column>-->
          <el-table-column
            :label="$t('app.modules.orders.headers.delivery_date')"
          >
            <template slot-scope="scope">
              <fg-input>
                <el-date-picker v-model="scope.row._fechaEntrega" format="dd-MM-yyyy" type="date"/>
              </fg-input>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('app.modules.orders.headers.quantity')"
          >
            <template slot-scope="scope">
              <input type="text" v-model="scope.row.quantity" class="form-control">
              <!--<el-input-number v-model="scope.row.quantity" @change="quantityChange" :min="1" :max="1000"></el-input-number>-->
            </template>
          </el-table-column>
          <el-table-column
            fixed="right"
            :label="$t('app.general.actions')"
          >
            <div slot-scope="props" class="table-actions dropdown">
              <n-button
                @click.native="addProduct(props.$index, props.row)"
                class="like"
                type="info"
                size="sm"
                round
                icon
              >
                <i class="fa fa-plus"></i>
              </n-button>
            </div>
          </el-table-column>
        </el-table>
      </div>
      <div class="row col-12 d-flex">
      </div>
    </card>

    <card card-body-classes="table-full-width px-4 pb-3" no-footer-line>
      <div class="row">
        <div class="col-12">
          <h4 class="card-title text-purple">
            {{ $t("app.modules.orders.add.selected_products") }}
          </h4>

          <el-table stripe style="width: 100%;" :data="pedido.productosSeleccionados">
            <el-table-column :label="$t('app.modules.orders.headers.product')">
              <template slot-scope="scope">
                {{ scope | product('denominacion') }}
              </template>
            </el-table-column>

            <el-table-column  :label="$t('app.modules.orders.headers.price')">
              <template slot-scope="scope">
                {{ scope | product('importe')|currenciFormat() }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('app.modules.orders.headers.unit')">
              <template slot-scope="scope">
                {{scope|product('unidadMedida')}}
              </template>
            </el-table-column>
            <el-table-column :label="$t('app.modules.orders.headers.quantity')">
              <template slot-scope="{row}">
                {{ row.quantity}}
              </template>
            </el-table-column>
            <el-table-column :label="$t('app.modules.orders.headers.subtotal')">
              <template slot-scope="{row}">
                {{ row.subtotal|currenciFormat()}}
              </template>
            </el-table-column>
            <el-table-column :label="$t('app.modules.orders.headers.delivery_date')">
              <template slot-scope="{row}">
                {{row.fecha_entrega_usuario}}
              </template>
            </el-table-column>
            <el-table-column :label="$t('app.modules.orders.headers.quit')">
              <div slot-scope="props" class="table-actions dropdown">
                <n-button
                  @click.native="removeProduct(props.$index)"
                  class="like"
                  type="danger"
                  size="sm"
                  round
                  icon
                >
                  <i class="fa fa-trash fa-2x"></i>
                </n-button>
              </div>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </card>

    <card card-body-classes="table-full-width px-4 pb-3" no-footer-line>

      <div class="row form-group">
        <label for="" class="col-form-label col-12">Orden de compra</label>
        <div class="col-12">
          <input class="form-control mb-2" type="text" v-model="pedido.ordenCompraStr">
        </div>
        <div class="col-12">
          <file-input :input-props="{accept: 'application/pdf'}" v-model="files"/>
        </div>
      </div>

      <div class="row">
        <div class="col-12 text-center">
          <button type="button" class="btn btn-primary btn-lg" @click="onClickSave">
            {{$t("app.modules.orders.form.save")}}
          </button>
        </div>
      </div>
    </card>
  </div>
</template>

<script>
import Pedido from '@/models/pedidos/Pedido'
import {array_set_value, getResponse} from "@/util/utilities";
import OrderItemInformation from "@/models/pedidos/OrderItemInformation";
import FileInput from "@/components/Inputs/FileInput";
import {Direccion} from "@/models/pedidos/Direccion";

export default {
  name: "PedidoForm",

  components: {
    FileInput
  },

  props: {
    value: {
      type: Pedido,
      default: () => new Pedido(),
    },
    edit: Boolean
  },

  data()
  {
    return {
      pedido: this.value,
      clientes: [],
      productos: [],
      files: [],
      direcciones: [],
      tiposPedido: [],
      contactos: []
    }
  },

  mounted()
  {
    this.init();
  },

  watch: {
    value: {
      deep: true,
      handler(value)
      {
        this.pedido = value;
      }
    },

    pedido: {
      deep: true,
      handler(value)
      {
        this.$emit('input', value);
      }
    },

    "pedido.idCliente": {
      async handler(value) {
        array_set_value(this.pedido.productosSeleccionados, []);
        array_set_value(this.direcciones, []);
        array_set_value(this.contactos, []);
        this.pedido.direccionEntregaId = undefined;
        await this.getDirecciones(value);
        await this.getContactos(value);
      }
    },
    "pedido.direccionEntregaId":{
      async handler(value){
        array_set_value(this.pedido.productosSeleccionados, []);
        await this.getProductos(value);
      }
    },

    files(value)
    {
      this.pedido.orden = value[0];
    }
  },

  methods: {
    async init(){
      this.showLoader();

      if (!!this.pedido.idCliente)
      {
        await this.getProductos()
      }

      if (!!!this.edit)
      {
        await this.getClients();
      }
      this.getTyposPedidos();

      this.$swal.close();
    },

    showLoader()
    {
      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false
      });
    },

    async getClients(){
      await this.$http.get(route("Clientes/getAllClientes"))
        .then(
          response => {
            if (response.body.code === 200){
              this.clientes = response.body.clientes
            }
            else{
              console.log(response.body.message);
            }
          },
          error => {
            console.error(error);
          }
        );
    },

    async getTyposPedidos(){
      await this.$http.get(route("Pedidos/getTiposPedido"))
        .then(
          response => {
            if (response.body.code === 200){
              this.tiposPedido = response.body.tiposPedido
            }
            else{
              console.log(response.body.message);
            }
          },
          error => {
            console.error(error);
          }
        );
    },
    async getProductos(id){
      console.log(this.pedido.idCliente);
      const params = {
        /*Id: id,
        ClaveIdioma: this.$store.state.lang,
        Usuario: 0,*/
        clienteId: this.pedido.idCliente,
        direccionId: this.pedido.direccionEntregaId
      };

      this.productos = [];

      try {
        let productosRequest = await this.$http
          .post(route("Productos/GetProductosByCliente"), params)

        let productos = getResponse(productosRequest, null, body => body.productos);
        productos = productos || [];
        productos = productos.map(product => {
          return new OrderItemInformation({product, quantity: 0});
        });

        this.productos = productos;
      }
      catch (e)
      {
        console.error(e);
      }
    },
    async getContactos(id){
      const params = {
        clienteId: id
      };
      await this.$http.post(route("Clientes/getContactosByCliente"), params)
        .then(
          response => {
            if (response.body.code === 200){
              this.contactos = getResponse(response, null, body => body.contactos);
            }
            else{
              console.log(response.body.message);
            }
          },
          error => {
            console.error(error);
          }
        );
    },
    async getDirecciones(id)
    {
      const params = {
        clienteId: id
      };

      try {
        let direccionesRequest = await this.$http.post(route('Clientes/GetDireccionesByCliente'), params);
        let direcciones = getResponse(direccionesRequest, null, body => body.direcciones);
        this.direcciones = direcciones.map(item => new Direccion(item));
      }
      catch (e)
      {
        console.error(e);
      }
    },

    addProduct(index, row){
      try {
        if (!!!row) {
          throw new Error(this.$t('app.modules.orders.errors.data_unprovided'))
        }

        if (!!!row._fechaEntrega)
        {
          throw new Error(this.$t('app.modules.orders.errors.date_unprovided'))
        }

        this.pedido.productosSeleccionados.push( new OrderItemInformation(row) );
        row._fechaEntrega = null;
        row.quantity = 0;
      }
      catch (e)
      {
        this.notifyMessage('danger', e.message);
      }
    },

    removeProduct(index)
    {
      this.pedido.productosSeleccionados.splice(index, 1);
    },

    getValue()
    {
      return this.pedido;
    },

    fileChange(evt)
    {
      debugger;
    },

    onClickSave()
    {
      try {
        if (!!!this.pedido)
        {
          throw new Error(this.$t('app.modules.orders.errors.no_order'));
        }

        if (!!!this.pedido.idCliente)
        {
          throw new Error(this.$t('app.modules.orders.errors.no_client_id'));
        }

        if (!!!this.pedido.productosSeleccionados || this.pedido.productosSeleccionados.length === 0)
        {
          throw new Error(this.$t('app.modules.orders.errors.no_order_selected_products'));
        }

        if (!!!this.pedido.direccionEntregaId)
        {
          throw new Error(this.$t('app.modules.orders.errors.no_delivery_address_id'));
        }

        this.$emit('send', this.pedido);
      }
      catch (e)
      {
        this.notifyMessage('danger', e.message);
      }
    }
  },

  filters: {
    product(value, prop = null)
    {
      let row = value.row;
      if (!!row)
      {
        let product = row.product;
        if (!!product && !!prop)
        {
          return product[prop];
        }

        return product;
      }

      return null;
    },
    currenciFormat(value) {
      if(value){
        let val = (value/1).toFixed(2).replace(',', '.');
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
      return null;
    }
  },
  computed: {
    title()
    {
      return !this.edit ? this.$t("app.modules.orders.form.new_order"): this.$t("app.modules.orders.form.edit_order");
    }
  }
}
</script>

<style scoped>

</style>
